import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/carousel/btn-prev.png'
import _imports_1 from '@/assets/img/carousel/btn-next.png'


const _withScopeId = n => (_pushScopeId("data-v-07839cc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carousel" }
const _hoisted_2 = {
  class: "carousel__images",
  ref: "carouselImagesRef"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "carousel__indicators" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["carousel-image", [_ctx.imgActive === index && 'active']]),
          key: index,
          onClick: ($event: any) => (_ctx.clickImg(img))
        }, [
          _createElementVNode("img", {
            src: img?.url,
            alt: "img"
          }, null, 8, _hoisted_4)
        ], 10, _hoisted_3))
      }), 128))
    ], 512),
    _createElementVNode("div", {
      class: "carousel__btn-prev",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPrev && _ctx.onPrev(...args)))
    }, _hoisted_6),
    _createElementVNode("div", {
      class: "carousel__btn-next",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
    }, _hoisted_8),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images.length, (i, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["indicator", _ctx.indicatorActive === index && 'active']),
          key: i,
          onClick: ($event: any) => (_ctx.selectIndicator(index))
        }, null, 10, _hoisted_10))
      }), 128))
    ])
  ]))
}